import React from 'react';
import { Shield, Mail, Facebook, Users } from 'lucide-react';

const PrivacyPolicyPage = () => {
  return (
    <div style={{ padding: '2rem 0' }}>
      {/* Header Section */}
      <section className="section">
        <div 
          className="card card-with-bg"
          style={{
            backgroundImage: `url('/images/land-cruiser-5.jpg'), linear-gradient(135deg, rgba(0, 0, 0, 0.85) 0%, rgba(23, 23, 23, 0.8) 100%)`,
            backgroundBlendMode: 'overlay',
            textAlign: 'center',
            padding: '3rem 2rem'
          }}
        >
          <Shield size={48} style={{ color: '#ffffff', marginBottom: '1rem', margin: '0 auto 1rem auto' }} />
          <h1 style={{ color: 'white', fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '1rem' }}>
            Privacy Policy
          </h1>
          <p style={{ color: '#d4d4d4', fontSize: '1.125rem', maxWidth: '600px', margin: '0 auto' }}>
            Your privacy matters to us. Learn how we protect your information in our Toyota Land Cruiser community.
          </p>
        </div>
      </section>

      {/* Privacy Policy Content */}
      <section className="section">
        <div className="card" style={{ maxWidth: '800px', margin: '0 auto', padding: '3rem' }}>
          
          {/* Last Updated */}
          <div style={{ 
            background: 'rgba(255, 255, 255, 0.05)', 
            padding: '1rem', 
            borderRadius: '0.5rem', 
            marginBottom: '2rem',
            textAlign: 'center'
          }}>
            <p style={{ color: '#94a3b8', margin: 0 }}>
              <strong>Last Updated:</strong> July 20, 2025
            </p>
          </div>

          {/* Introduction */}
          <div style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#ffffff', fontSize: '1.5rem', marginBottom: '1rem' }}>Introduction</h2>
            <p style={{ color: '#d4d4d4', lineHeight: '1.7' }}>
              Welcome to Dixieland Cruisers ("we," "our," or "us"). We are Birmingham, Alabama's premier Toyota Land Cruiser and 4WD enthusiast community. This Privacy Policy explains how we collect, use, and protect your information when you visit our website and participate in our community activities.
            </p>
          </div>

          {/* Information We Collect */}
          <div style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#ffffff', fontSize: '1.5rem', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <Users size={20} />
              Information We Collect
            </h2>
            
            <h3 style={{ color: '#ffffff', fontSize: '1.25rem', marginBottom: '0.75rem', marginTop: '1.5rem' }}>
              Currently
            </h3>
            <p style={{ color: '#d4d4d4', lineHeight: '1.7', marginBottom: '1rem' }}>
              Our website currently operates with minimal data collection:
            </p>
            <ul style={{ color: '#d4d4d4', lineHeight: '1.7', paddingLeft: '1.5rem' }}>
              <li><strong>Website Usage:</strong> We do not use cookies, tracking pixels, or analytics tools</li>
              <li><strong>Event Registration:</strong> We redirect you to Facebook Events for event sign-ups; we do not collect this information directly</li>
              <li><strong>Contact Information:</strong> We do not currently have contact forms on our website</li>
            </ul>

            <h3 style={{ color: '#ffffff', fontSize: '1.25rem', marginBottom: '0.75rem', marginTop: '1.5rem' }}>
              Future Collection
            </h3>
            <p style={{ color: '#d4d4d4', lineHeight: '1.7', marginBottom: '1rem' }}>
              We may add the following features in the future:
            </p>
            <ul style={{ color: '#d4d4d4', lineHeight: '1.7', paddingLeft: '1.5rem' }}>
              <li><strong>Membership Dues:</strong> Name, email, payment information for annual dues</li>
              <li><strong>Merchandise Sales:</strong> Contact and shipping information for club merchandise</li>
              <li><strong>Email Communications:</strong> Email addresses for club newsletters and updates</li>
              <li><strong>Contact Forms:</strong> Information you voluntarily provide to contact us</li>
            </ul>
          </div>

          {/* How We Use Information */}
          <div style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#ffffff', fontSize: '1.5rem', marginBottom: '1rem' }}>How We Use Your Information</h2>
            <p style={{ color: '#d4d4d4', lineHeight: '1.7', marginBottom: '1rem' }}>
              When we do collect information in the future, we will use it to:
            </p>
            <ul style={{ color: '#d4d4d4', lineHeight: '1.7', paddingLeft: '1.5rem' }}>
              <li>Manage club membership and communicate about events</li>
              <li>Process membership dues and merchandise orders</li>
              <li>Send newsletters and updates about club activities</li>
              <li>Respond to your inquiries and provide customer support</li>
              <li>Improve our website and services</li>
            </ul>
          </div>

          {/* Information Sharing */}
          <div style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#ffffff', fontSize: '1.5rem', marginBottom: '1rem' }}>Information Sharing</h2>
            <p style={{ color: '#d4d4d4', lineHeight: '1.7', marginBottom: '1rem' }}>
              We may share your information with:
            </p>
            <ul style={{ color: '#d4d4d4', lineHeight: '1.7', paddingLeft: '1.5rem' }}>
              <li><strong>Toyota Land Cruiser Association (TLCA):</strong> We may share member information with TLCA for coordination of activities and events</li>
              <li><strong>Service Providers:</strong> Third-party services that help us operate our website and process payments (when implemented)</li>
              <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
            </ul>
            <p style={{ color: '#d4d4d4', lineHeight: '1.7', marginTop: '1rem' }}>
              We will never sell your personal information to third parties for marketing purposes.
            </p>
          </div>

          {/* Third-Party Services */}
          <div style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#ffffff', fontSize: '1.5rem', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <Facebook size={20} />
              Third-Party Services
            </h2>
            <p style={{ color: '#d4d4d4', lineHeight: '1.7', marginBottom: '1rem' }}>
              Our website links to Facebook Events for event registration. When you click "Join Adventure," you'll be redirected to Facebook, which has its own privacy policy. We encourage you to review Facebook's Privacy Policy to understand how they handle your information.
            </p>
          </div>

          {/* Data Security */}
          <div style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#ffffff', fontSize: '1.5rem', marginBottom: '1rem' }}>Data Security</h2>
            <p style={{ color: '#d4d4d4', lineHeight: '1.7' }}>
              We take reasonable measures to protect your information from unauthorized access, alteration, disclosure, or destruction. When we implement data collection features, we will use industry-standard security practices including encrypted data transmission and secure storage.
            </p>
          </div>

          {/* Data Retention */}
          <div style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#ffffff', fontSize: '1.5rem', marginBottom: '1rem' }}>Data Retention</h2>
            <p style={{ color: '#d4d4d4', lineHeight: '1.7' }}>
              When we begin collecting personal information, we will retain it only as long as necessary to provide our services and comply with legal obligations. You may request deletion of your personal information at any time by contacting us.
            </p>
          </div>

          {/* Your Rights */}
          <div style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#ffffff', fontSize: '1.5rem', marginBottom: '1rem' }}>Your Rights</h2>
            <p style={{ color: '#d4d4d4', lineHeight: '1.7', marginBottom: '1rem' }}>
              When we collect personal information, you have the right to:
            </p>
            <ul style={{ color: '#d4d4d4', lineHeight: '1.7', paddingLeft: '1.5rem' }}>
              <li>Access and review your personal information</li>
              <li>Correct inaccurate or incomplete information</li>
              <li>Request deletion of your personal information</li>
              <li>Opt-out of email communications</li>
              <li>Withdraw consent for data processing</li>
            </ul>
          </div>

          {/* Children's Privacy */}
          <div style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#ffffff', fontSize: '1.5rem', marginBottom: '1rem' }}>Children's Privacy</h2>
            <p style={{ color: '#d4d4d4', lineHeight: '1.7' }}>
              Our services are not directed to children under 13. We do not knowingly collect personal information from children under 13. If we learn that we have collected personal information from a child under 13, we will delete that information promptly.
            </p>
          </div>

          {/* Changes to This Policy */}
          <div style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#ffffff', fontSize: '1.5rem', marginBottom: '1rem' }}>Changes to This Privacy Policy</h2>
            <p style={{ color: '#d4d4d4', lineHeight: '1.7' }}>
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date. We encourage you to review this Privacy Policy periodically.
            </p>
          </div>

          {/* Contact Information */}
          <div style={{ 
            background: 'rgba(255, 255, 255, 0.05)', 
            padding: '2rem', 
            borderRadius: '1rem', 
            border: '1px solid rgba(255, 255, 255, 0.1)' 
          }}>
            <h2 style={{ color: '#ffffff', fontSize: '1.5rem', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <Mail size={20} />
              Contact Us
            </h2>
            <p style={{ color: '#d4d4d4', lineHeight: '1.7', marginBottom: '1rem' }}>
              If you have any questions about this Privacy Policy or our data practices, please contact us:
            </p>
            <div style={{ color: '#ffffff' }}>
                <p style={{ margin: '0.5rem 0' }}>
              <strong>President:</strong> Ryan Fleming
              </p>
              <p style={{ margin: '0.5rem 0' }}>
                <strong>Email:</strong> <a href="mailto:ryan@rkfleming.com" style={{ color: '#60a5fa', textDecoration: 'none' }}>ryan@rkfleming.com</a>
              </p>
              <p style={{ margin: '0.5rem 0' }}>
                <strong>Organization:</strong> Dixieland Cruisers
              </p>
              <p style={{ margin: '0.5rem 0' }}>
                <strong>Location:</strong> Birmingham, Alabama
              </p>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;